/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { TimePicker as CarbonTimePicker } from 'carbon-addons-iot-react';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { FormLabelTooltip } from 'Common';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired, // needed for accessibility
  tooltip: PropTypes.string,
  learnMore: PropTypes.string,
  required: PropTypes.bool,
  validate: PropTypes.func,
  hideLabel: PropTypes.bool,
};

const defaultProps = {
  tooltip: null,
  learnMore: null,
  required: true,
  validate: null,
  hideLabel: false,
};

const TimePickerFormik = ({ id, label, hideLabel, required, tooltip, learnMore, ...other }) => {
  const [field, meta, helpers] = useField({ name: id });

  const labelComponent = (
    <FormLabelTooltip label={label} required={required} tooltip={tooltip} learnMore={learnMore} />
  );

  return (
    <CarbonTimePicker
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      id={id}
      labelText={labelComponent}
      required={required}
      onChange={e => helpers.setValue(e.target.value)}
      value={field.value}
      hideLabel={hideLabel}
      invalid={!!meta.error}
      invalidText={meta.error}
    />
  );
};

TimePickerFormik.propTypes = propTypes;
TimePickerFormik.defaultProps = defaultProps;

export default TimePickerFormik;
